import React, {Fragment} from 'react'
import {Route, Redirect, Switch} from "react-router-dom";
import OperatorScreen from "../screens/operator/OperatorScreen";
import OperatorProfile from "../screens/operator/profile/OperatorProfile";
import OperatorChangePassword from "../screens/operator/profile/OperatorChangePassword";
import OperatorBankDetails from "../screens/operator/wallet/OperatorBankDetails";
import OperatorRequestPayout from "../screens/operator/wallet/OperatorRequestPayout";
import OperatorViewWallet from "../screens/operator/wallet/OperatorViewWallet";
import OperatorJobHistory from "../screens/operator/jobs/OperatorJobHistory";
import OperatorNewJobs from "../screens/operator/jobs/OperatorNewJobs";
import OperatorPendingJobs from "../screens/operator/jobs/OperatorPendingJobs";
import OperatorAcceptedJobs from "../screens/operator/jobs/OperatorAcceptedJobs";
import OperatorRejectedJobs from "../screens/operator/jobs/OperatorRejectedJobs";
import Page_not_found from "../screens/404_page/404";

const OperatorRoutes = () => {
    return (
        <Switch>
            <Redirect exact from="/login" to="/operator"/>
            <Redirect exact from="/register" to="/operator"/>
            <Redirect exact from="/" to="/operator"/>

            <Route path="/operator" component={OperatorScreen} exact/>
            <Route path='/operator/profile' component={OperatorProfile} exact/>
            <Route path='/operator/change_password' component={OperatorChangePassword} exact/>
            <Route path='/operator/bank_details' component={OperatorBankDetails} exact/>
            <Route path='/operator/request_payout' component={OperatorRequestPayout} exact/>
            <Route path='/operator/view_wallet' component={OperatorViewWallet} exact/>
            <Route path='/operator/job_history' component={OperatorJobHistory} exact/>
            <Route path='/operator/new_jobs' component={OperatorNewJobs} exact/>
            <Route path='/operator/pending_jobs' component={OperatorPendingJobs} exact/>
            <Route path='/operator/accepted_jobs' component={OperatorAcceptedJobs} exact/>
            <Route path='/operator/rejected_jobs' component={OperatorRejectedJobs} exact/>
            <Route component={Page_not_found}/>


        </Switch>
    )
}

export default OperatorRoutes